<template>
  <v-card outlined rounded="lg" class="pa-3 h-100">
    <div class="section-card-title">
      <v-icon color="#B3151B" class="mr-2">mdi-chart-bar</v-icon>
      ผู้เรียนแยกตามประเภทวิชา
      <span class="section-card-count">{{ numberWithCommas(countAll) }} คน</span>
    </div>

    <div v-if="countAll > 0">
      <apexchart type="bar" height="380" :options="chartOptions" :series="series"></apexchart>
    </div>
    <div v-else class="text-center grey--text pa-6">ไม่พบข้อมูลนักเรียนของสถานศึกษานี้</div>
  </v-card>
</template>

<script>
// รับข้อมูลจาก parent (collegesid.vue) — ดู stdLevel.vue สำหรับเหตุผลที่เลิก fetch เอง
export default {
  name: "DashboardOvecMasterStdBranch",
  props: {
    rows: { type: Array, default: () => [] }
  },
  computed: {
    byType() {
      const map = {};
      this.rows.forEach(r => {
        const type = r.subjectTypeNameTh || "ไม่ระบุประเภทวิชา";
        map[type] = (map[type] || 0) + (parseInt(r.cnt) || 0);
      });
      return map;
    },
    countAll() {
      return Object.values(this.byType).reduce((a, b) => a + b, 0);
    },
    series() {
      return [{ data: Object.values(this.byType) }];
    },
    chartOptions() {
      const labelText = Object.keys(this.byType);
      return {
        chart: { type: "bar", height: 380 },
        plotOptions: {
          bar: {
            borderRadius: 10,
            barHeight: "100%",
            distributed: true,
            horizontal: true,
            dataLabels: { position: "bottom" }
          }
        },
        colors: ["#B3151B", "#1B365D", "#A86400", "#424242", "#8E1014", "#9E9E9E", "#212121", "#E57373"],
        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: { fontSize: "12px", colors: ["#fff"] },
          formatter: (val, opt) => opt.w.globals.labels[opt.dataPointIndex] + ":  " + val,
          offsetX: 50
        },
        stroke: { width: 1, colors: ["#fff"] },
        xaxis: { categories: labelText },
        yaxis: { labels: { show: false } },
        tooltip: { theme: "dark", x: { show: false }, y: { title: { formatter: () => "" } } }
      };
    }
  },
  methods: {
    numberWithCommas(x) {
      x = String(x);
      const pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
      return x;
    }
  }
};
</script>

<style scoped>
.h-100 {
  height: 100%;
}
.section-card-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-weight: 700;
  color: #1b365d;
  font-size: 1rem;
  margin-bottom: 8px;
}
.section-card-count {
  margin-left: auto;
  font-weight: 700;
  color: #b3151b;
}
</style>
